import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { showChat } from '../../../utils/liveChat';
import Button from '../../common/base/Button';
import { StyledCard } from '../../common/base/Card';
import Container from '../../common/base/Container';
import Text from '../../common/base/Text';
import { Div } from '../../common/helpers/StyledUtils';
import { useMemberTrial } from '../../hooks/useMemberTrial';
import { DashboardContext } from './DashboardContext';
export const StyledPaywallWrapper = styled.div`
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: absolute;

  > div {
    z-index: ${({
  theme
}) => theme.zindex.modal};
    position: relative;
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${({
  theme
}) => theme.colors.surface.base.backdrop};
    z-index: ${({
  theme
}) => theme.zindex.sticky + 1};
    backdrop-filter: blur(1px);
    border-left: 1px solid ${({
  theme
}) => theme.colors.outline.neutral};
  }
`;
const TeamMemberOverLimitModal = () => {
  const $ = _c(15);
  const {
    subscription,
    organization_role
  } = useContext(DashboardContext);
  const location = useLocation();
  const {
    is_member_trial_active
  } = useMemberTrial(subscription);
  let t0;
  if ($[0] !== is_member_trial_active || $[1] !== location || $[2] !== organization_role || $[3] !== subscription?.max_users) {
    t0 = !is_member_trial_active && subscription?.max_users === 1 && organization_role !== "owner" && !location.pathname.includes("/settings");
    $[0] = is_member_trial_active;
    $[1] = location;
    $[2] = organization_role;
    $[3] = subscription?.max_users;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const eligible = t0;
  let t1;
  let t2;
  if ($[5] !== eligible) {
    t1 = () => {
      if (eligible) {
        document.body.style.overflow = "hidden";
        return _temp;
      }
    };
    t2 = [eligible];
    $[5] = eligible;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  if (!eligible) {
    return null;
  }
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "center",
      justify: "center"
    };
    t4 = {
      vh: 100
    };
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text bold={true} size="xl" center={true} m={{
      b: 4
    }}>Users over plan limit</Text>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    t7 = <br />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text center={true}>Your free plan only allows a single user on the organization. Only the organization owner can have access.{t6}{t7}To re-enable your access, ask your organization owner to upgrade your plan.{" "}<strong>Upgrade your plan</strong> to continue using Hookdeck or ask the owner to upgrade your plan.</Text>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <StyledPaywallWrapper><Container small={true} flex={t3} h={t4}><StyledCard p={8} raised={3}>{t5}{t8}<Div flex={{
            justify: "center",
            gap: 3
          }} m={{
            t: 6
          }}><Button onClick={showChat} icon="chat" outline={true}>Contact us</Button><Button to="/settings/organization/plans?highlight=max_users" icon="upgrade">Upgrade plan</Button></Div></StyledCard></Container></StyledPaywallWrapper>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default TeamMemberOverLimitModal;
function _temp() {
  document.body.style.overflow = "visible";
}